import DapDSSpinner from './spinner.component'

export * from './spinner.component'
export default DapDSSpinner

DapDSSpinner.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-spinner': DapDSSpinner
  }
}
